module.exports = __webpack_public_path__ + "img/money-bill-1.a04ea3c4.svg";